import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';  // Ajout de cet import

const firebaseConfig = {
  apiKey: "AIzaSyBUCdAFnB-0kaDOmnSkXUASvnysoBCuFXc",
  authDomain: "glmri-6182e.firebaseapp.com",
  projectId: "glmri-6182e",
  storageBucket: "glmri-6182e.firebasestorage.app",
  messagingSenderId: "601381352509",
  appId: "1:601381352509:web:3ae63c46df1594d4eda654",
  measurementId: "G-CQ3TPW4J00"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const db = getFirestore(app);  // J'ai changé firestore en db pour correspondre à  import
export default app;